var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackingD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5386_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66668 3.33333H7.95628C9.98777 3.33333 11.0035 3.33333 11.3891 3.69819C11.7224 4.01357 11.8701 4.47818 11.7801 4.92814C11.676 5.44867 10.8467 6.03523 9.1882 7.20835L6.47849 9.12497C4.81995 10.2981 3.99067 10.8847 3.88657 11.4052C3.79658 11.8551 3.94429 12.3198 4.27759 12.6351C4.66317 13 5.67892 13 7.71041 13H8.33334M5.33334 3.33333C5.33334 4.4379 4.43791 5.33333 3.33334 5.33333C2.22877 5.33333 1.33334 4.4379 1.33334 3.33333C1.33334 2.22876 2.22877 1.33333 3.33334 1.33333C4.43791 1.33333 5.33334 2.22876 5.33334 3.33333ZM14.6667 12.6667C14.6667 13.7712 13.7712 14.6667 12.6667 14.6667C11.5621 14.6667 10.6667 13.7712 10.6667 12.6667C10.6667 11.5621 11.5621 10.6667 12.6667 10.6667C13.7712 10.6667 14.6667 11.5621 14.6667 12.6667Z",
    stroke: "#C7C4BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5386_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingD);
export default __webpack_public_path__ + "static/media/tracking-d.bc4a2ea8f01e2f488966b2a0beacbc49.svg";
export { ForwardRef as ReactComponent };